import { render, staticRenderFns } from "./AgregarTema.vue?vue&type=template&id=fce3c606&scoped=true"
import script from "./AgregarTema.vue?vue&type=script&lang=js"
export * from "./AgregarTema.vue?vue&type=script&lang=js"
import style0 from "./AgregarTema.vue?vue&type=style&index=0&id=fce3c606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce3c606",
  null
  
)

export default component.exports